import { Button } from "@mui/material";
import React from "react";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {

  const navigate = useNavigate();

  return (
    <div>
      <div className="headerMain_Page" style={{ position: "fixed" }}>
        <Button className="back_Button" onClick={() => navigate(-1)}>
          <IoMdArrowRoundBack
            style={{ color: "white", height: "30px", width: "30px" }}
          />
        </Button>
        <p
          style={{
            color: "white",
            width: "80%",
            fontWeight: 600,
            margin: "0px",
            fontSize: "18px",
          }}
        >
          Privacy Policy
        </p>
      </div>
      <div style={styles.container}>
        <p style={styles.date}>
          Effective Date: <b>25-12-2024</b>
        </p>

        <section style={styles.section}>
          <p style={styles.text}>
            We prioritize your privacy and data security. The Admin App collects
            personal and usage information to provide, improve, and secure our
            services.
          </p>
        </section>

        <section style={styles.section}>
          <h3 style={styles.subHeader}>Data Collected:</h3>
          <p style={styles.text}>
            Personal details (e.g., name, email), usage data, and system
            information (e.g., user roles, reports).
          </p>
        </section>

        <section style={styles.section}>
          <h3 style={styles.subHeader}>Usage:</h3>
          <p style={styles.text}>
            For app functionality, access control, notifications, and analytics.
          </p>
        </section>

        <section style={styles.section}>
          <h3 style={styles.subHeader}>Sharing:</h3>
          <p style={styles.text}>
            Data is not sold. It is shared only with service providers or for
            legal compliance.
          </p>
        </section>

        <section style={styles.section}>
          <h3 style={styles.subHeader}>Security:</h3>
          <p style={styles.text}>
            We use encryption, access controls, and audits to protect your
            information.
          </p>
        </section>

        <section style={styles.section}>
          <h3 style={styles.subHeader}>Your Rights:</h3>
          <p style={styles.text}>
            Access, update, or request deletion of your data by contacting{" "}
            support@orail.in
          </p>
        </section>

        <section style={styles.section}>
          <h3 style={styles.subHeader}>Retention:</h3>
          <p style={styles.text}>
            Data is kept as long as necessary and securely deleted when no
            longer needed.
          </p>
        </section>

        <section style={styles.section}>
          <h3 style={styles.subHeader}>Questions:</h3>
          <p style={styles.text}>For questions, email support@orail.in</p>
        </section>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "90%",
    margin: "0 auto",
    padding: "70px 16px",
    fontFamily: "Arial, sans-serif",
    color: "#333",
  },
  header: {
    fontSize: "20px",
    textAlign: "center",
    marginBottom: "12px",
  },
  date: {
    fontSize: "12px",
    textAlign: "center",
    marginBottom: "12px",
    color: "#666",
  },
  section: {
    marginBottom: "12px",
  },
  subHeader: {
    fontSize: "16px",
    marginBottom: "6px",
    color: "#000",
  },
  text: {
    fontSize: "12px",
    lineHeight: "1.4",
    color: "#444",
  },
  link: {
    color: "#007BFF",
    textDecoration: "none",
  },
};

export default PrivacyPolicy;
